import React from "react";
import styles from "./Loader.module.scss";

interface LoaderProps {
  fullscreen?: boolean;
}


export default function Loader({ fullscreen = false }: LoaderProps) {
  return (
    <div
      className={
        fullscreen ? styles.fullscreenContainer : styles.loaderContainer
      }
    >
      <div className={styles.spinner} />
      <div className={styles.text}>Загрузка...</div>
    </div>
  );
}
